import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

export type ChildrenProps<T = unknown> = PropsWithChildren<T>;

interface ProtectedRouteProps {
  allowed: boolean;
  redirect: string;
}

export const ProtectedRoute = ({
  children,
  redirect,
  allowed,
}: ChildrenProps<ProtectedRouteProps>): JSX.Element => {
  if (!allowed) {
    return <Navigate to={redirect} />;
  }

  return <>{children}</>;
};
